import { Operation } from 'types';

const formatterByOperation: Record<
  Operation,
  { lang: string; currency: string }
> = {
  [Operation.BR]: {
    lang: 'pt-BR',
    currency: 'BRL',
  },
  [Operation.ES]: {
    lang: 'es-PE',
    currency: 'PEN',
  },
};

export const convertToCurrency = (
  operation: Operation = Operation.BR,
  value: number
) => {
  const formattedValue = new Intl.NumberFormat(
    formatterByOperation[operation].lang,
    {
      style: 'currency',
      currency: formatterByOperation[operation].currency,
    }
  ).format(value);

  return formattedValue;
};

export const getRoundedValue = (
  value: number,
  installment?: number,
  operation?: Operation
) => {
  if (installment) {
    const roundedValue =
      Math.round((value / installment + Number.EPSILON) * 100) / 100;

    return convertToCurrency(operation, roundedValue);
  }

  const roundedValue = Math.round((value + Number.EPSILON) * 100) / 100;

  return convertToCurrency(operation, roundedValue);
};

/** @deprecated */
export const verifyMultiProfilePlan = (plan = '') =>
  plan?.includes('multiprofile') || plan?.includes('multi-profile');

interface GetMultiProfilePlanProps {
  plans: Array<{
    plan: string;
    planType: string;
    business: string;
    productCode: string;
  }>;
}

export const getMultiProfilePlan = ({ plans }: GetMultiProfilePlanProps) =>
  plans?.find((item) => verifyMultiProfilePlan(item?.plan));
